import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-detail-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerDetailAdminEffects {

    BenutzerDetailAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_DETAIL_ADMIN),
        mergeMap((x: ac.GetBenutzerDetailAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerDetailAdmin(x.benutzerId).pipe(
                map((result: any) => {
                    return new ac.GetBenutzerDetailAdminErfolgreichAction(result, x.benutzerId, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerDetailAdminFehlerAction(error, x.benutzerId, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminQueryService);
        }
        return this.service;
    }
}
